import React, { useEffect, useRef, useState } from 'react';


import Navbar from '../../components/navbar';
import { MetaTagHandler } from '../../../library/client/serverCallHandler';

import Footer from '../../components/footer';





const Tokenomics = () => {




    return (
        <>

            <MetaTagHandler>
                {() => (
                    <>
                        <title> Tokenomics | PLURI</title>
                        <meta name="description" content="PLURI Tokenomics is a unique approach to the distribution of PLURI. Learn more about how PLURI is distributed and how you can earn PLURI." />
                        <meta property="og:title" content="PLURI | Tokenomics" />
                        <meta property="og:description" content="PLURI Tokenomics is a unique approach to the distribution of PLURI. Learn more about how PLURI is distributed and how you can earn PLURI." />
                        <meta property="og:image" content={`https://${process.env.REACT_APP_ORIGIN}/assets/pluriBanner.png`} />
                        <meta property="og:url" content={`https://${process.env.REACT_APP_ORIGIN}/tokenomics`} />
                        <meta property="og:site_name" content="PLURI" />
                        <meta property="og:type" content="website" />
                        <meta property="og:locale" content="en_US" />

                    </>
                )}
            </MetaTagHandler>
            <div className='content-wrapper'>
                <ul>
                    <li><a href="#features">Features</a>

                    </li>
                    <li><a href="#tokenomics">How does the tokenomics work?</a>
                        <ul>
                            <li><a href="#definitions">Definitions</a></li>
                            <li><a href="#proccess">Proccess</a></li>
                        </ul>
                    </li>
                    <li><a href="#distribution">Visual of example distribution</a>
                        <ul>
                            <li><a href="#example">Example Distribution</a></li>
                            <li><a href="#epoch">Epoch Rewards for Stakeholders</a></li>
                            <li><a href="#public">Epoch Rewards for public people that claim at the faucet</a></li>
                        </ul>

                    </li>
                </ul>
                <div className='content-feed'>
                    <h1>Tokenomics</h1>
                    <p className='content-feed-subtitle' >This contract is used to stake Pluri tokens and distribute rewards to stakers and the faucet.</p>
                    <h3 id='features'>Features</h3>
                    <ul>
                        <li>Automatic distrubution of Pluri for users and stakers.</li>
                        <li>Automatic self regulating quantity of Pluri minted to balance inflation.</li>
                        <li>Taxes from Pluri contract are divided among stakeholders, and users whom claim from the faucet.</li>
                        <li>Orphaned contract to prevent rule changes.</li>
                        <li>Stakeholder rug pull prevention, stakeholders won't be able to unstake in mass. Every 30 days, a max potential amount of unstakes are generated. 8% of the epochs stakeholders at time of calculation. Minimum of 30 days required to have the oppurtunity to unstake.</li>
                        <li>Tokens that are distrubuted via mints do not contain transaction history, while tokens collected from taxes will be decoupled from their transaction histroy.</li>
                        <li>Incase of an urgent exploit(s), the contract will be removed of it's mint status from the Pluri token contract and a new stakeholder and faucet contract will be deployed allowing updates. Stakeholders will be able to unstake immediatly if this occurs and mints will no longer occur protecting financial stability.</li>
                        <li>Anybody can earn Pluri by using the faucet, costing only the native tokens gas amount.</li>
                    </ul>
                    <h3 id='tokenomics'>How does the tokenomics work?</h3>
                    <h4 id='definitions'>Definitions:</h4>
                    <ul>
                        <li>Wait List - A queue that tracks the order, staked and unstaked stakeholders</li>
                        <li>Epoch - A list genreated from the wait list, tracks whom to distrubute rewards to.</li>
                        <li>Faucet - A seperate contract that is always the last stakeholder in the lists. Provides the public the ability to claim Pluri (Call auto mint function)</li>
                        <li>Tax - Collected tax from data transactions from Pluri contract.</li>
                        <li>Staking - To lock 21,000 Pluri tokens within the staking contract for 30 days minimum, earning more Pluri in the process.</li>
                        <li>Unstake - To withdrawl 21,000 Pluri from the staking contract, no longer earning stakeholder rewards.</li>
                        <li>Faucet Claim - The ability to use the faucet to earn Pluri. Each claim is generated in 60 second intervals.</li>
                        <li>Gas - Fee required to successfully conduct a transaction or execute a contract with the chains native token.</li>
                        <li>Tax reward - The stakeholders contract balance of Pluri divided by epoch list size (balance of pluri / epoch stakeholder count)</li>
                    </ul>
                    <h4 id='proccess'>Proccess:</h4>
                    <ol>
                        <li>11 people and the faucet become stakeholders</li>
                        <li>The 12 stakeholders are entered into the wait list</li>
                        <li>An epoch is generated and copys the wait list order of stakeholders</li>
                        <li>The tax reward is determined (balance of pluri in stakeholder contract / epoch stakeholder count), if tax reward cannot be given evenly, no tax reward will be given</li>
                        <li>Every 60 seconds a possible faucet claim is generated</li>
                        <li>A public user triggers a faucet claim, paying a small transaction fee (gas)</li>
                        <li>The epoch then picks whose turn it is to receive rewards based on the order</li>
                        <li>1 Pluri is minted to the selected stakeholder and tax rewards are transferred</li>
                        <li>The public user is minted (1 / epoch list size) of Pluri, and (tax reward / epoch list size) of tax reward is transferred to the public user</li>
                        <li>(Repeat 5-8 until it's faucets turn)</li>
                        <li>When a public user triggers a faucet claim, when it's the faucets turn in the epoch, no Pluri is minted to the faucet. The public user recieves minted (1 / epoch list size) of Pluri, and (tax reward / epoch list size) of tax reward transferred, with a bonus remainder value for the minted and tax</li>
                        <li>After reaching the faucet's turn, the epoch ends, and the cycle starts over from step 3</li>
                    </ol>
                    <h3 id='distribution'>Visual of example distribution</h3>
                    <h4 id='example'>Example Distribution:</h4>
                    <p>
                        Epoch list size = 12
                        <br />
                        Stakeholder contract balance of Tax = 0.0000014 Pluri
                        <br />
                        Stakeholder Reward (SR) = 1 Pluri
                        <br />
                        Claim Reward (CR) = 0.0833... Pluri ( / epoch list size)
                        <br />
                        Claim Reward Remainder (CRR) = 0.000000000000000004 Pluri (1 % epoch list size)
                        <br />
                        <br />
                        Tax Reward (TR) = 0.0000001 Pluri ( Stakeholder contract balance of Tax / epoch list size)
                        <br />
                        Faucet Tax Reward (FTR) = 0.000000008333... Pluri (Tax Reward / epoch list size)
                        <br />
                        Faucet Tax Reward Remainder (FTRR) = 0.000000000000000004 Pluri (FTR % epoch list size)
                        <br />
                        <br />
                        (P) - Pluri Token
                        <br />
                        S Reward - Stakeholder base reward
                        <br />
                        ST Reward - Stakeholder tax reward
                        <br />
                        <br />
                        U Reward - Public User base reward
                        <br />
                        UT Reward - Public User tax reward
                        <br />

                    </p>
                    <h4 id='epoch'>Epoch Rewards for Stakeholders</h4>

                    <table>
                        <tbody>
                        <tr>
                            <th>Stakeholders</th>
                            <th>user1</th>
                            <th>user2</th>
                            <th>user3</th>
                            <th>user4</th>
                            <th>user5</th>
                            <th>user6</th>
                            <th>user7</th>
                            <th>user8</th>
                            <th>user9</th>
                            <th>user10</th>
                            <th>user11</th>
                            <th>faucet</th>
                        </tr>
                        <tr>
                            <td>S Reward</td>
                            <td>SR</td>
                            <td>SR</td>
                            <td>SR</td>
                            <td>SR</td>
                            <td>SR</td>
                            <td>SR</td>
                            <td>SR</td>
                            <td>SR</td>
                            <td>SR</td>
                            <td>SR</td>
                            <td>SR</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>ST Reward</td>
                            <td>TR</td>
                            <td>TR</td>
                            <td>TR</td>
                            <td>TR</td>
                            <td>TR</td>
                            <td>TR</td>
                            <td>TR</td>
                            <td>TR</td>
                            <td>TR</td>
                            <td>TR</td>
                            <td>TR</td>
                            <td>0</td>
                        </tr>
                        </tbody>
                      
                    </table>
                    <h4 id='public'>Epoch Rewards for public people that claim at the faucet</h4>
                    <table>
                        <tbody>
                        <tr>
                            <th>Claims</th>
                            <th>person1</th>
                            <th>person2</th>
                            <th>person3</th>
                            <th>person4</th>
                            <th>person5</th>
                            <th>person6</th>
                            <th>person7</th>
                            <th>person8</th>
                            <th>person9</th>
                            <th>person10</th>
                            <th>person11</th>
                            <th>person12</th>
                        </tr>
                        <tr>
                            <td>U
                            </td>
                            <td>CR</td>
                            <td>CR</td>
                            <td>CR</td>
                            <td>CR</td>
                            <td>CR</td>
                            <td>CR</td>
                            <td>CR</td>
                            <td>CR</td>
                            <td>CR</td>
                            <td>CR</td>
                            <td>CR</td>
                            <td>CR + CRR</td>
                        </tr>
                        <tr>
                            <td>UT</td>
                            <td>FTR</td>
                            <td>FTR</td>
                            <td>FTR</td>
                            <td>FTR</td>
                            <td>FTR</td>
                            <td>FTR</td>
                            <td>FTR</td>
                            <td>FTR</td>
                            <td>FTR</td>
                            <td>FTR</td>
                            <td>FTR</td>
                            <td>FTR + FTRR</td>
                        </tr>
                        </tbody>
                      
                    </table>





                </div>
            </div>


            <Footer />




        </>
    );
};

export default Tokenomics;
